import { ReactNode } from 'react';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';

import ResponseModalStyles from './ResponseModal.module.scss';

interface IResponseModal {
  isShow: boolean;
  icon?: any;
  title?: any;
  subTitle?: ReactNode;
  btnTitle?: string;
  onPress?: () => void;
  onClose: () => void;
  onClickAway: () => void;
  onBack: () => void;
  isShowCloseIcon?: boolean;
}

const ResponseModal = ({
  isShow,
  icon,
  title,
  subTitle,
  btnTitle,
  onPress,
  onClickAway,
  onBack,
  onClose,
  isShowCloseIcon
}: IResponseModal) => {
  return (
    <Modal
      onClickAway={onClickAway}
      onBack={onBack}
      onClose={onClose}
      isShow={isShow}
      isShowCloseIcon={isShowCloseIcon}
      isShowBottomLogo={false}>
      <div className={ResponseModalStyles.wrapper}>
        <div className={ResponseModalStyles.wrapper__icon}>{icon}</div>

        {title && <div className={ResponseModalStyles.wrapper__title}>{title}</div>}

        {subTitle && <div className={ResponseModalStyles.wrapper__subTitle}>{subTitle}</div>}

        {btnTitle && (
          <div>
            <Button title={btnTitle} backgroundColor="#5941A9" onPress={onPress} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ResponseModal;
